const attributes = {
  toast: {
    error: {
      badResponse: 'Error de actualización de [atributo]',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Atributo] se actualizó correctamente',
      },
      delete: {
        body: 'Los atributos se eliminaron correctamente',
      },
    },
  },
  table: {
    headerButtons: {
      create: 'Crear',
      delete: {
        label: 'Eliminar',
        deleteModal: {
          header: 'Eliminar atributos',
          body: 'Está a punto de eliminar {{attributes}} atributos',
        },
      },
      clear: {
        label: 'Borrar',
        clearModal: {
          header: 'Borrar atributos',
          body: 'Está a punto de borrar {{attributes}} atributos',
        },
      },
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    placeholder: {
      select: 'Seleccionar',
    },
    headers: {
      name: 'Nombre',
      labels: 'Etiquetas',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  form: {
    header: {
      createAttribute: {
        title: 'Crear',
      },

      updateAttribute: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Información general',
        fields: {
          name: 'Nombre',
          description: 'Descripción',
        },
      },

      aliases: {
        header: 'Asignación de nombre de atributo',
        fields: {
          drivers: 'Conductores',
          vehicles: 'Vehículos',
          bookings: 'Reservas',
        },
      },
      advanced: {
        header: 'Configuración avanzada',
        fields: {
          sharedRideRatio: 'Proporção Máxima de Tempo Compartilhado',
          maxSharedDistanceRatio: {
            label: 'Proporção Máxima de Distância Compartilhada',
            description: 'Define quanto uma viagem compartilhada pode ser mais longa em comparação com a distância solo. Exemplo: Se a distância solo é 1 milha e a proporção é 1,2x, a viagem compartilhada não pode exceder 1,2 milhas',
          },
          maxSinglePassengerTime: 'Tiempo máximo de viaje para un solo pasajero',
          maxPassengers: 'Máx. Pasajeros',
          maxTripStops: 'Paradas Máx.',
          tripBoardingTime: 'Tiempo de Embarque',
          tripDropOffTime: 'Tiempo de Desembarque',
          attributeReassignment: 'Habilitar el cambio de ruta de atributos',
          attributeReassignmentDescription:
            'Cuando se habilita, esta configuración activa el cambio de ruta automático de expediciones en respuesta a las actualizaciones en atributos de reserva específicos. Sin habilitar esta configuración, los cambios de atributos no generarán un cambio de ruta de expedición.',
          matchScore: 'Habilitar la coincidencia de atributos de conductor / vehículo',
          matchScoreDescription:
            'Habilitar esta configuración permite que el sistema tenga en cuenta la coincidencia de atributos al asignar conductores o vehículos a las reservas. Sin habilitar esta configuración, el sistema ignorará ese atributo al hacer coincidencias de conductores / vehículos-reservas.',
          maxBoardingDelay: 'Retraso máximo de embarque',
          maxBoardingEarly: 'Antelación máxima de embaeque',
          maxDropOffEarly: {
            label: 'Adelanto máximo de entrega',
            description:
              'Número máximo de minutos que un conductor puede adelantarse respecto al tiempo de entrega establecido en la reserva.',
          },
          maxDropOffDelay: {
            label: 'Retraso máximo de entrega',
            description:
              'Número máximo de minutos que un conductor puede llegar tarde respecto al tiempo de entrega establecido en la reserva.',
          },
          minScore: 'Puntaje mínimo',
          waitAndReturn: 'Esperar y regresar',
          waitAndReturnDescription:
            'La duración en minutos que un conductor esperará entre los tramos de salida y de vuelta de un viaje de espera y vuelta.',
          off: 'Desactivado',
          maxPassengerAtOnce: 'Máximo de pasajeros a la vez',
          maxPickupStops: 'Máximo de paradas para subidas',
          maxDropoffStops: 'Máximo de paradas para bajadas',
          onlyPrivate: 'Solo Privado',
          maxSimultaneousBookings: 'Máximo de Reservas Simultáneas',
          sharedWith: 'Compartido con',
          willCallTimeOffset: 'Desfase de Tiempo de Will Call',
          leg: {
            label:'Habilitar como Tramo',
            description: 'Este tramo ya está asignado a otro atributo.'
          }
        },
      },
    },
    valdations: {
      name: {
        required: 'El nombre es obligatorio',
        name: 'Nombre no válido',
      },
      unit: {
        required: 'La unidad es obligatoria',
        name: 'Unidad no válida',
      },
      parameters: {
        required: 'Los parámetros son obligatorios',
        name: 'Revise con cuidado los valores que está pasando',
      },
    },
    create: {
      toastError: {
        message: 'No se pudo crear',
      },
      toastSuccess: {
        message: 'Creado correctamente',
      },
    },

    update: {
      formTabs: {
        generalInfo: 'General',
        advanced: 'Configuración avanzada',
        history: 'Historia',
      },

      toastError: {
        message: 'No se pudo actualizar',
      },
      toastSuccess: {
        message: 'Actualizado correctamente',
      },
    },
  },
};

export default attributes;
